module.exports = __webpack_public_path__ + "static/media/expert-chat-welcome-team.d7fe936c.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/expert-chat-welcome-team.jpg
// module id = 1420
// module chunks = 0